import { Calendar, CheckCircle, Clock, Dock, DoorOpen, FileText, Mail, MapPin, MessageSquare, Phone, User } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { NotificationSound } from "../../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, deleteData, getDateAndTime, handleDateChange, sanitizeInput } from "../../CommonComponents/CustomHooks";
import { initializeFilterData } from "../../CommonComponents/EnvConfig";
import { DateBox, FormButton, InputBox, SelectInputBox, Switch, TextareaBox } from "../../CommonComponents/InputBox";
import { setSubLoading } from "../../Redux/Services/AuthSlice";


const LeadEntryFollowUpDetails = () => {

    const query = new URLSearchParams(window.location.search);
    const LeadNo = query.get("LeadNo");
    const inputrefs = useRef([])
    const dispatch = useDispatch([])
    const [isLoading, setIsLoading] = useState(false);
    const [leadFollowUpData, setLeadFollowUpData] = useState({})
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });

    const initialState = {
        followUpID: '0',
        followUpDate: getDateAndTime().date,
        nextFollowUpDate: getDateAndTime().date,
        nextFollowUpTime: "",
        followUpRemarks: "",
        noFurtherFollowUp: false,
        finalRemarks: "",
        finalStatus: "",
        convertedDate: "",
        reson: "",
        followUpType: "",
        leadNo: LeadNo,
        followUpDetails: []
    }

    //--inital State--//
    const [formData, setFormData] = useState(initialState);

    //--Get Data Function--//
    const getLeadFollowUpDetailsData = async () => {
        const data = {
            ...formData,
        };
        setIsLoading(true);
        let res = await ApiCall("/api/LeadEntry/ShowLeadFollowUp", data);
        if (res.Status === "SUCCESS") {
            const mappedRecords = res.Data.map((item, index) => ({
                id: item.FollowUpID || index,
                followUpType: item.FollowUpType,
                followUpDate: item.FollowUpDate,
                createdDate: item.CreatedDate,
                createdBy: item.CreatedBy,
                nextFollowUp: item.NextFollowUpDate,
                remarks: item.FollowupRemarks,
                noFurtherFollowUp: item.NoFurtherFollowUp,
                finalStatus: item.FinalStatus,
                finalRemarks: item.FinalRemarks,
            }));
            setRecords(mappedRecords);
        }
        else if (res.Status === "ERROR") {
            setRecords([]);
        }
        setIsLoading(false);
        if (res.Status === "EXPIRED") {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    };


    const GetStatus = DropDownData('GetFollowUpStatus')
    const GetFollow = DropDownData('GetFollowUp')

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/LeadEntry/LeadFollowUpEdit`, { followUpID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'SUCCESS') {
            //await inputrefs.current[editData.focus].focus();
            setFormData((pre) => ({
                ...pre, ...editData.data,
            }))
        } else {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/LeadEntry/DeleteLeadFollowUp`, { followUpID: id }, getLeadFollowUpDetailsData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }


    const GetLeadEntryFollowUpPageData = async (id) => {

        setIsLoading(true)
        let res = await ApiCall(`/api/LeadEntry/GetLeadEntryFollowUp`, { LeadNo: id })
        if (res.status === 'SUCCESS') {
            setLeadFollowUpData(res.data);
        } else if (res.status === 'ERROR') {
            setLeadFollowUpData({});
        }
        setIsLoading(false)

    }

    //--handleClear Function--//
    const handleClear = () => {
        setFormData(initialState)
        filterData.SearchText = ''
        getLeadFollowUpDetailsData()
    }

    const handleChange1 = (event, value) => {
        getLeadFollowUpDetailsData(value);
    };

    //--handle Sorting--//
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/LeadEntry/InsertUpdateFollowUpDetails`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const InfoRow = ({ label, value, icon }) => (
        <div className="group flex text-break items-center justify-start p-1 transition-all duration-300 rounded-lg">
            <div className="items-center gap-3">
                {icon && (
                    <div className="w-5 h-5 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white group-hover:scale-110 transition-transform duration-300 shadow-md">
                        {icon}
                    </div>
                )}
                <span className="text-gray-600 font-medium">{label}</span>
            </div>
            <span className="font-semibold text-sm text-gray-800  p-2  transition-shadow duration-300">
                {value || "-"}
            </span>
        </div>
    );

    const getFollowUpIcon = (followUpType) => {
        switch (followUpType) {
            case "Mail":
                return <Mail className="w-5 h-5 text-blue-600" />;
            case "Call":
                return <Phone className="w-5 h-5 text-green-600" />;
            case "Visit":
                return <DoorOpen className="w-5 h-5 text-orange-600" />;
            default:
                return null;
        }
    };


    useEffect(() => {
        document.title = 'Lead Entry Follow Up Details'
        getLeadFollowUpDetailsData()
    }, [sortConfig]);


    //--Handle Grid Info--//
    const [records, setRecords] = useState([]);

    const fetchFollowUps = async () => {
        try {
            const res = await fetch("API_URL_HERE");
            const json = await res.json();

            if (json.Status === "SUCCESS") {
                const mappedData = json.Data.map((item, index) => ({
                    id: item.LeadEntryID || index,
                    followUpType: item.FollowUpType || "�",
                    followUpDate: item.FollowUpDate || "�",
                    nextFollowUp: item.NextFollowUpDate || "",
                    remarks: item.FollowupRemarks || "�",
                    createdBy: item.CreatedBy || "�",
                    createdDate: item.CreatedDate || "�",
                    noFurtherFollowUp: !item.NextFollowUpDate,
                    finalStatus: item.FinalStatus || "Pending",
                    finalRemarks: item.FinalRemarks || "",
                }));
                setRecords(mappedData);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const getStatusBadge = (status) => {
        const colors = {
            QUALIFIED: "bg-green-100 text-green-800 border-green-300",
            Pending: "bg-yellow-100 text-yellow-800 border-yellow-300",
            Running: "bg-blue-100 text-blue-800 border-blue-300",
        };
        return colors[status] || "bg-gray-100 text-gray-800 border-gray-300";
    };

    useEffect(() => {
        if (LeadNo) {
            GetLeadEntryFollowUpPageData(LeadNo)
        }
    }, [LeadNo])

    const Info = ({ label, children }) => (
        <div>
            <p className="text-xs font-semibold text-gray-500 mb-2">{label}</p>
            <div className="flex items-center gap-2 text-gray-800 text-sm">
                {children}
            </div>
        </div>
    );

    useEffect(() => {
        fetchFollowUps();
    }, []);

    return (
        <>
            <div className='bg-white rounded-lg shadow-sm p-6 mb-6'>
                <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                        <Dock className="w-6 h-6 text-teal-600" />
                        <h2 className="text-xl font-semibold text-gray-800">Lead Entry Follow Up Details</h2>
                    </div>
                </div>
                <div className=''>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">

                        <div className="bg-white rounded-lg shadow-sm p-3 border-t-4 border-blue-500">
                            <div className="flex gap-3">
                                <h3 className="font-semibold text-lg text-blue-600 flex items-center gap-2">
                                    <FileText className="w-5 h-5" />Lead Information
                                </h3>
                                <div className="text-sm text-gray-700 mt-1.5">
                                    <span className="font-medium">{leadFollowUpData?.leadNo}</span> | {leadFollowUpData?.leadDate}
                                </div>
                            </div>


                            <InfoRow value={leadFollowUpData?.customerName} icon={<User size={14} />} />
                            <InfoRow value={leadFollowUpData?.address} icon={<MapPin size={14} />} />
                            <div className="grid grid-cols-1 lg:grid-cols-2">
                                <InfoRow value={leadFollowUpData?.contactNo} icon={<Phone size={14} />} />
                                <InfoRow value={leadFollowUpData?.emailID} icon={<Mail size={14} />} />
                            </div>
                        </div>


                        <div className="bg-white rounded-lg shadow-sm p-3 border-t-4 border-red-500">
                            <div className="flex items-center">
                                <h3 className="font-semibold text-lg text-red-600 flex items-center gap-2">
                                    <Clock className="w-5 h-5" /> FollowUp Details
                                </h3>
                                <div className="text-sm text-gray-700 ms-3">
                                    <span className="font-medium">{leadFollowUpData?.salesPerson}</span>
                                </div>
                            </div>
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2.5">
                                <InfoRow value={leadFollowUpData?.lastFollowUpDate} icon={<Calendar size={14} />} />
                                <InfoRow value={leadFollowUpData?.lastFollowUpRemark} icon={<MessageSquare size={14} />} />
                            </div>
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2.5">
                                <InfoRow value={leadFollowUpData?.nextFollowUpDate} icon={<Calendar size={14} />} />
                            </div>
                        </div>

                        <div className="bg-white rounded-lg shadow-sm p-3 border-t-4 border-green-500">
                            <h3 className="font-semibold text-lg text-green-600 flex items-center gap-2">
                                <CheckCircle className="w-5 h-5" />  Final Status
                            </h3>
                            <InfoRow value={leadFollowUpData?.status} icon={<CheckCircle size={14} />} />
                            <InfoRow value={leadFollowUpData?.finalRemarks} icon={<MessageSquare size={14} />} />
                            <InfoRow
                                value={leadFollowUpData?.requirements?.split("\r\n").map((line, i) => (
                                    <div key={i}>{line}</div>
                                ))}
                                icon={<MessageSquare size={14} />}
                            />
                        </div>
                    </div>

                    <div className="panel panel-primary mt-3">
                        <div className="panel-heading py-1 px-2" style={{ fontSize: '13px', fontWeight: '600', backgroundColor: '#DBEAFD', color: ' var(--text-black)' }}> <i className="fa-solid fa-bookmark"></i>  Follow Up Details</div>
                        <div className="panel-body pb-1 px-2" style={{ border: '1px solid #DBEAFD' }} >
                            <div className="row mx-0 my-2">

                                <SelectInputBox
                                    id="txtFollowUpType"
                                    required={true}
                                    value={formData.followUpType}
                                    label='Follow Up Type'
                                    onChange={(e) => setFormData({ ...formData, followUpType: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['ddlRelevant'].focus()
                                        }
                                    }}
                                >

                                    <option value=''>--Please Select--</option>
                                    {GetFollow?.data?.dropDownData?.map((item, index) =>
                                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                                    )}

                                </SelectInputBox>

                                {/*    <SelectInputBox*/}
                                {/*        id="ddlRelevant"*/}
                                {/*        value={formData.relevant}*/}
                                {/*        required={true}*/}
                                {/*        label='Relevant'*/}
                                {/*        onChange={(e) => setFormData({ ...formData, relevant: e.target.value })}*/}
                                {/*        inputrefs={inputrefs}*/}
                                {/*        onKeyDown={(e) => {*/}
                                {/*            if (e.key === 'Enter') {*/}
                                {/*                inputrefs.current['txtFollowUpDate'].focus()*/}
                                {/*            }*/}
                                {/*        }}*/}
                                {/*    >*/}

                                {/*        <option value=''>--Select--</option>*/}
                                {/*        <option value='Yes'>Yes</option>*/}
                                {/*        <option value='No'>No</option>*/}

                                {/*</SelectInputBox>*/}

                                <DateBox
                                    inputrefs={inputrefs}
                                    label="Follow Up Date"
                                    placeholder="DD-MMM-YYYY"
                                    id='txtFollowUpDate'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtNextFollowUpDate'].focus()
                                        };
                                    }}
                                    disabled
                                    selected={formData.followUpDate === '' ? '' : new Date(formData.followUpDate)}
                                    onChange={(e) => handleDateChange(e, setFormData, formData, 'followUpDate')}
                                />

                                <DateBox
                                    inputrefs={inputrefs}
                                    label="Next Follow Up Date"
                                    placeholder="DD-MMM-YYYY"
                                    id='txtNextFollowUpDate'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtNextFollowUpTime'].focus()
                                        };
                                    }}
                                    required={true}
                                    selected={formData.nextFollowUpDate === '' ? '' : new Date(formData.nextFollowUpDate)}
                                    onChange={(e) => handleDateChange(e, setFormData, formData, 'nextFollowUpDate')}
                                    disabled={formData.noFurtherFollowUp}
                                />

                                <InputBox
                                    id="txtNextFollowUpTime"
                                    type="time"
                                    label='Next Follow Up Time'
                                    required={true}
                                    maxLength='50'
                                    value={formData.nextFollowUpTime}
                                    onChange={(e) => setFormData({ ...formData, nextFollowUpTime: sanitizeInput(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtFollowUpRemarks'].focus() };
                                    }}
                                    divclassname="col-md-3"
                                />


                                <TextareaBox
                                    id="txtFollowUpRemarks"
                                    label="Follow Up Remarks"
                                    placeholder="Follow Up Remarks"
                                    required={true}
                                    maxLength="250"
                                    rows="1"
                                    value={formData.followUpRemarks}
                                    inputrefs={inputrefs}
                                    onChange={(e) => setFormData({ ...formData, followUpRemarks: sanitizeInput(e.target.value) })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtNoFurtherFollowUp'].focus()
                                        };
                                    }}
                                    disabled={formData.noFurtherFollowUp}
                                    divclassname="col-md-3 "
                                />

                                <Switch
                                    size='lg'
                                    divclassname='col-md-3  cntrl-width mt-4'
                                    inputrefs={inputrefs}
                                    label='No Further Follow Up'
                                    checked={formData.noFurtherFollowUp}
                                    id='txtNoFurtherFollowUp'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            !formData.noFurtherFollowUp ? inputrefs.current['txtbtnSub'].focus() : inputrefs.current['txtFinalStatus'].focus();
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, noFurtherFollowUp: e.target.checked, finalStatus: "", convertedDate: "", finalRemarks: "", followUpRemarks: "", nextFollowUpDate: "" })}
                                />
                                {formData.noFurtherFollowUp && <>
                                    <SelectInputBox
                                        id="txtFinalStatus"
                                        value={formData.finalStatus}
                                        label='Final Status'
                                        required={true}
                                        onChange={(e) => setFormData({ ...formData, finalStatus: e.target.value })}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtConvertedDate'].focus()
                                            }
                                        }}
                                    >

                                        <option value=''>--Please Select--</option>
                                        {GetStatus?.data?.dropDownData?.map((item, index) =>
                                            <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                                        )}

                                    </SelectInputBox>

                                    {formData.finalStatus === 'Converted to Order' && <DateBox
                                        inputrefs={inputrefs}
                                        label="Converted Date"
                                        placeholder="Converted Date"
                                        id='txtConvertedDate'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtFinalRemarks'].focus()
                                            };
                                        }}
                                        selected={formData.convertedDate === '' ? '' : new Date(formData.convertedDate)}
                                        onChange={(e) => handleDateChange(e, setFormData, formData, 'convertedDate')}
                                    />}

                                    <TextareaBox
                                        id="txtFinalRemarks"
                                        label="Final Remarks"
                                        divclassname='col-md-3 mb-1 cntrl-width '
                                        placeholder="Enter Final Remarks"
                                        maxLength="250"
                                        rows="1"
                                        required={true}
                                        value={formData.finalRemarks}
                                        inputrefs={inputrefs}
                                        onChange={(e) => setFormData({ ...formData, finalRemarks: sanitizeInput(e.target.value) })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                inputrefs.current['txtbtnSub'].focus()
                                            };
                                        }}

                                    />

                                </>}


                                <FormButton
                                    extraclassname='mt-0'
                                    id={'txtbtnSub'}
                                    inputrefs={inputrefs}
                                    handleSubmit={handleSubmit}
                                    Export={false}
                                    handleClear={handleClear}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mt-3 bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 rounded-lg p-3 shadow-sm">

                        <div className="flex items-center justify-between mb-2">
                            <div className="flex items-center gap-2">
                                <FileText className="w-6 h-6 text-blue-900" />
                                <span className="text-lg font-semibold text-black">
                                    FollowUp Details: {records.length}
                                </span>
                            </div>
                        </div>

                        <div className="text-sm text-gray-800 leading-relaxed whitespace-pre-wrap">
                            {records.map((record, index) => (
                                <div key={index} className="flex items-start gap-2 mb-3">
                                    <div className="mt-1">
                                        {getFollowUpIcon(record.followUpType)}
                                    </div>

                                    <div>
                                        <span className="font-bold text-primary text-lg">Dated: </span><span className="text-lg">{record.followUpDate} ({record.createdDate}) - {record.createdBy}</span>
                                        <span className="font-bold text-primary text-lg ms-3">Next Follow-up Date: </span><span className="text-lg"> {record.nextFollowUp || "Not Required"} </span>
                                        <br />
                                        <span className="text-lg">{record.remarks || record.finalRemarks || "-"}</span>
                                        <span className="text-lg">{record.finalStatus} <span className="font-bold text-primary text-lg">Next Follow-up Time: </span><span className="text-lg"> {leadFollowUpData.nextFollowUpTime} </span></span>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>


                </div>

                {/*    <div className='row  mb-2 mt-2'>*/}
                {/*        <div className="panel panel-primary">*/}
                {/*            <div className="panel-heading py-1 px-2"*/}
                {/*                style={{ fontSize: '13px', fontWeight: '600', backgroundColor: '#DBEAFD', color: 'var(--text-black)' }}>*/}
                {/*                <i className="fa-solid fa-circle-info"></i> Item Detail*/}
                {/*            </div>*/}

                {/*            <div className="panel-body pb-1 px-2" style={{ border: '1px solid #DBEAFD' }} >*/}

                {/*                <div className="panel panel-primary mt-2">*/}
                {/*                    <div className="panel-heading py-1 px-2"*/}
                {/*                        style={{ fontSize: '13px', fontWeight: '600', backgroundColor: '#DBEAFD' }}>*/}
                {/*                        Total Records: {leadFollowUpData?.itemDeatils?.length || 0}*/}
                {/*                    </div>*/}

                {/*                    <div className="panel-body">*/}
                {/*                        {*/}
                {/*                            (!leadFollowUpData?.itemDeatils ||*/}
                {/*                                leadFollowUpData?.itemDeatils?.length === 0) ? (*/}
                {/*                                <div style={{*/}
                {/*                                    padding: "25px 10px", textAlign: "center", background: "#EFF6FF", border: "1px dashed #D1D5DB", borderRadius: "8px", marginTop: "10px",*/}
                {/*                                    marginBottom: "10px",*/}
                {/*                                }}*/}
                {/*                                >*/}
                {/*                                    <i className="fa-solid fa-box-open" style={{*/}
                {/*                                        fontSize: "26px",*/}
                {/*                                        color: "#9CA3AF",*/}
                {/*                                        marginBottom: "8px"*/}
                {/*                                    }}*/}
                {/*                                    ></i>*/}

                {/*                                    <div style={{ fontSize: "14px", fontWeight: "600", color: "#6B7280" }}>*/}
                {/*                                        No Records Found*/}
                {/*                                    </div>*/}

                {/*                                    <div style={{ fontSize: "12px", color: "#9CA3AF", marginTop: "3px" }}>*/}
                {/*                                        Try adjusting your filters or add new items.*/}
                {/*                                    </div>*/}
                {/*                                </div>*/}

                {/*                            ) : (*/}
                {/*                                <div className="table-responsive"*/}
                {/*                                    style={{ maxHeight: "267px", overflowY: "auto", position: 'relative' }}>*/}

                {/*                                    <table className="table table-bordered table-striped">*/}
                {/*                                        <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>*/}
                {/*                                            <tr className="light-bg">*/}

                {/*                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Group</th>*/}
                {/*                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Item</th>*/}
                {/*                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Quantity</th>*/}
                {/*                                            </tr>*/}
                {/*                                        </thead>*/}

                {/*                                        <tbody>*/}
                {/*                                            {leadFollowUpData?.itemDeatils?.map((item, index) => (*/}
                {/*                                                <tr key={index} className="TableTrhover">*/}

                {/*                                                    <td style={{ padding: "3px" }}>{item.group}</td>*/}
                {/*                                                    <td style={{ padding: "3px" }}>{item.item}</td>*/}
                {/*                                                    <td style={{ padding: "3px" }}>{item.qty}</td>*/}

                {/*                                                </tr>*/}
                {/*                                            ))}*/}
                {/*                                        </tbody>*/}
                {/*                                    </table>*/}

                {/*                                </div>*/}
                {/*                            )}*/}
                {/*                    </div>*/}

                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*</div>*/}


            </div>
        </>
    )
}


export default LeadEntryFollowUpDetails;